import Pikaday from "pikaday";

export default class BDatepicker
{
	static selector = () => `.b-datepicker`;
	static classInitialized = () => `b-datepicker--pikaday`;

	static initialize()
	{
		document.querySelectorAll(this.selector()).forEach(el => {
			if (!el.placeholder.trim()) {
				el.placeholder = "d.m.r";
			}

			if (!el.classList.contains(this.classInitialized())) {
				const widget = new Pikaday({
					// container: el.closest("dialog"),
					field: el,
					// bound: true,
					firstDay: 1,
					format: "D.M.YYYY",
					keyboardInput: false,
					placeholder: "d.m.r",
					theme: "b-datepicker-widget",
					yearRange: 100,
					i18n: {
						previousMonth: "Předchozí měsíc",
						nextMonth: "Následující měsíc",
						months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
						weekdays: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
						weekdaysShort: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
					},
				});

				el.classList.add(this.classInitialized());
			}
		});
	}
}
